import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { GA4_EVENT_SELECT_PROMOTION } from '@/data/constants/gtm';
import { useMobileApp } from '@/utils/useMobileApp';

import { useTrackException } from 'presentation/events/hooks/useTrackException';
import { triggerGA4EcommerceEvent } from 'presentation/events/services/ga4EcommerceService';
import { saveSelectedPromotionInSessionStorage } from 'presentation/events/services/promotionsService';
import { GA4SelectPromotionEventPayload } from 'presentation/events/types/ga4Types';
import { extractSelectPromotionEventProps, updateSelectedPromotionKeyWords } from './utils';

export const useTrackSelectPromotion = () => {
	const pathname = usePathname();
	const trackException = useTrackException();
	const { isMobileApp } = useMobileApp();

	useEffect(() => {
		if (!pathname) {
			return;
		}

		const onClick = (e: MouseEvent) => {
			try {
				const props = extractSelectPromotionEventProps(e.target, pathname);

				if (!props) {
					return;
				}

				const payload: GA4SelectPromotionEventPayload = {
					event: GA4_EVENT_SELECT_PROMOTION,
					ecommerce: {
						promotion_id: props.promotionId,
						promotion_name: props.promotionName,
						creative_name: props.creativeName,
						creative_slot: props.creativeSlot,
						click_source: props.clickSource,
					},
				};

				triggerGA4EcommerceEvent(payload);

				if (isMobileApp) {
					updateSelectedPromotionKeyWords(props.keyWords);
				} else {
					saveSelectedPromotionInSessionStorage({
						promotion_id: props.promotionId,
						promotion_name: props.promotionName,
						creative_name: props.creativeName,
						creative_slot: props.creativeSlot,
						key_words: props.keyWords,
						list_partnumbers: [],
					});
				}
			} catch (error) {
				console.error('Error sending select promotion event', error);
				trackException(error);
			}
		};

		document.addEventListener('click', onClick);

		return () => {
			document.removeEventListener('click', onClick);
		};
	}, [pathname, trackException, isMobileApp]);
};
